import React, { useRef } from "react";
import { useNavigate } from "@tanstack/react-router";
import MagneticButton from "../motion/MagneticButton";
import { useScrollReveal } from "../../hooks/useScrollReveal";

/**
 * End-of-home conversion strip — single path into Packages inquiry.
 */
const ConsultCTA: React.FC = () => {
  const ref = useRef<HTMLElement>(null);
  const navigate = useNavigate();
  useScrollReveal(ref);

  const goToConsult = () => {
    navigate({ to: "/packages", hash: "consult" });
  };

  return (
    <section
      ref={ref}
      id="book-consult"
      className="consult-cta relative my-16 md:my-24 overflow-hidden rounded-2xl border border-cyan-400/20"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-900 to-cyan-950" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(34,211,238,0.15),_transparent_55%)]" />

      <div className="relative z-10 px-6 py-12 md:px-12 md:py-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div data-reveal className="max-w-xl">
          <p className="text-cyan-400 font-mono text-sm tracking-widest uppercase mb-2">
            Next step
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
            Ready to build something that converts?
          </h2>
          <p className="text-white/70">
            Tell me about your product or site — I&apos;ll recommend a package
            or a custom scope within one business day.
          </p>
        </div>

        <div data-reveal className="flex flex-col sm:flex-row gap-3 shrink-0">
          <MagneticButton
            className="px-6 py-3 rounded-lg bg-cyan-500 text-slate-950 font-semibold hover:bg-cyan-400 transition-colors"
            onClick={goToConsult}
          >
            Book a consult
          </MagneticButton>
          <MagneticButton
            as="a"
            href="/projects"
            className="px-6 py-3 rounded-lg border border-white/25 text-white font-medium hover:border-cyan-400/60 hover:text-cyan-300 transition-colors"
            onClick={(e) => {
              e.preventDefault();
              navigate({ to: "/projects" });
            }}
          >
            View work
          </MagneticButton>
        </div>
      </div>
    </section>
  );
};

export default ConsultCTA;
